import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import APIClient from '../common/ApiClient'
import { ToastContainer, toast } from "react-toastify";

const NoticeDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [paramValue, setParamValue] = useState(null);
  const [pageData, setPageData] = useState(null);

  const getIdFromUrl = () => {
    const regex = /id=([A-Za-z0-9]+)/;
    const match = location.pathname.match(regex);

    if (match && match[1]) {
      return match[1];  // The first capture group (the value of the id)
    } else {
      return null;  // Return null if no id found
    }
  };

  const onNavBack = () => {
    navigate('/noticeDetails');
  }
  useEffect(() => {
    function getData() {
      
      const paramValue = getIdFromUrl();      
      APIClient.get('/noticeById', {
        params: {
          aan16: paramValue
        }
      }).then(response => {
        
        setPageData(response.data);
        toast.success(response.data.message, {
          position: "bottom-center",
          pauseOnHover: true,
          delay: true
        });
      }).catch(error => {
        if (error.response) {
          toast.error('Failed! ' + error.response.data, {
            position: "bottom-center",
            pauseOnHover: true
          });
        } else {
          toast.error(error.message, {
            position: "bottom-center",
            pauseOnHover: true
          });
        }
      });
    };
    getData();
  }, []);

  return (
    <div className="childPage">
      {/* <h2>Notice - AAN16</h2> */}
      <div className='displayPageWrapper' style={{marginTop: '10px', marginBottom: '30px', display: 'none'}}>

        {pageData ? Object.entries(pageData).map(([fieldName, fieldValue]) => (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))'}}>
              <label htmlFor="idType" style={{ display: 'block', marginBottom: '0px' }}>{fieldName}</label>
              <input
                id="idType"
                type="text"
                placeholder="Notice Type"
                value={fieldValue}
                title={fieldValue}
                style={{ padding: '5px', width: '100%' }}
              disabled/>
            </div>
        )) : (<div className='noDataDiv'>No Data</div>)}
      </div>

      <div className="form-container">
      {pageData ? Object.entries(pageData).map(([fieldName, fieldValue]) => (
          <div key={fieldName} className="form-row">
            <div className="field-name">{fieldName}:</div>
            <div className="field-value">{fieldValue}</div>
          </div>
        )): (<div className='noDataDiv'>No Data</div>)}
      </div>

    </div>
  );

}

export default NoticeDetails

